<div class="ai-helper-container">
	<!-- Sidebar -->
	<div class="ai-helper-sidebar">
		<button class="btn btn-primary btn-new-chat" (click)="createSession()">
			<i class="fa fa-plus"></i> New Chat
		</button>
		<div class="sessions-list">
			<div
				*ngFor="let session of sessions"
				class="session-item"
				[ngClass]="{ 'active': activeSessionId === session.id }"
				(click)="selectSession(session)"
			>
				<div class="session-title">{{ session.title }}</div>
				<div class="session-meta">
					<span class="session-count">{{ session.messageCount || 0 }} messages</span>
					<div class="session-meta-right">
						<span *ngIf="session.locale && session.locale !== 'en'" class="session-locale">{{ session.locale | uppercase }}</span>
						<button class="btn-delete" (click)="deleteSession($event, session)" title="Delete session">
							<i class="fa fa-trash-o"></i>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Main Chat Area -->
	<div class="ai-helper-main">
		<!-- Empty State -->
		<div *ngIf="!activeSessionId" class="empty-state">
			<i class="fa fa-comments-o empty-icon"></i>
			<h3>AI Helper</h3>
			<p>Ask questions about your chargers, batteries, and site data.</p>
			<button class="btn btn-primary" (click)="createSession()">Start New Chat</button>
		</div>

		<!-- Chat View -->
		<div *ngIf="activeSessionId" class="chat-view">
			<div class="messages-area" #messagesContainer>
				<div *ngFor="let msg of messages" class="message" [ngClass]="msg.role">
					<div class="message-bubble">
						<span *ngFor="let line of getLines(msg.content)"
							[ngClass]="{ 'table-line': isTableLine(line), 'bold-line': isBoldLine(line) }">{{ line }}<br></span>
					</div>
				</div>
				<div *ngIf="loading" class="message assistant">
					<div class="message-bubble typing-indicator">
						<span></span><span></span><span></span>
					</div>
				</div>
			</div>

			<div class="input-area">
				<textarea
					[(ngModel)]="newMessage"
					(keydown)="onKeyDown($event)"
					placeholder="Type a message... (Enter to send, Shift+Enter for new line)"
					rows="2"
					[disabled]="loading"
				></textarea>

				<!-- Language picker -->
				<div class="locale-picker-wrap" #localePicker (click)="$event.stopPropagation()">
					<button
						class="btn-locale-toggle"
						[class.active]="showLocalePicker"
						[title]="'Language / i18n preferences'"
						(click)="toggleLocalePicker($event)"
					>
						<i class="fa fa-globe"></i>
						<span class="locale-label">{{ localeButtonLabel }}</span>
					</button>

					<div class="locale-dropdown" *ngIf="showLocalePicker">
						<div class="locale-dropdown-header">
							<i class="fa fa-globe"></i> Language &amp; Format
						</div>
						<div *ngFor="let group of localeGroups">
							<div class="locale-group-label">{{ group }}</div>
							<button
								*ngFor="let loc of localesForGroup(group)"
								class="locale-option"
								[class.selected]="activeLocale === loc.code"
								(click)="selectLocale(loc, $event)"
							>
								<span class="locale-flag">{{ loc.flag }}</span>
								<span class="locale-name">{{ loc.name }}</span>
								<span class="locale-examples">{{ loc.dateExample }} &nbsp; {{ loc.numExample }}</span>
							</button>
						</div>
					</div>
				</div>

				<button class="btn btn-primary btn-send" (click)="sendMessage()" [disabled]="loading || !newMessage.trim()">
					<i class="fa fa-paper-plane"></i>
				</button>
			</div>
		</div>
	</div>
</div>
